import { render, staticRenderFns } from "./AttributeBookingTask.vue?vue&type=template&id=d7f06842"
import script from "./AttributeBookingTask.vue?vue&type=script&lang=js"
export * from "./AttributeBookingTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports